<template>
<div id="app">
  <div class="container-fluid pl-5 pr-5 mb-5">
    <span v-if="previewToggle === false">
      <div class="row">
        <div class="col-sm-12 col-md-8 pt-4">
          <resume @preview="togglePreview($event)" @setHelpSection="setSection($event)" @resumeExport="resumeExport($event)" />
        </div>
        <div class="col-sm-12 col-md-4">
          <div class="sticky-top mt-4">
            <help v-bind:section="helpSection" />
          </div>
        </div>
      </div>
    </span>
    <span v-if="previewToggle === true">
      <div class="row">
        <div class="col-sm-12 col-md-8 pt-4">
          <preview @preview="togglePreview()" />
        </div>
        <div class="col-sm-12 col-md-4 d-print-none">
          <div class="sticky-top mt-4">
            <help v-bind:section="helpSection" />
          </div>
        </div>
      </div>
    </span>
  </div>
</div>
</template>

<script>
import help from './components/help/help.vue';
import resume from './components/resume.vue';
import preview from './components/preview.vue';

export default {
  name: 'App',
  components: {
    resume,
    help,
    preview,
  },
  data() {
    return {
      date: new Date(),
      helpSection: '',
      previewToggle: false,
      formData: '',
      exportData: {
        applicationVersion: '20.4.0 Alpha',
      },
    }
  },
  methods: {

    // Passed the help section event to the help component.
    setSection(e) {
      this.helpSection = e;
    },

    // Exports resume data to a JSON file for the end use to download.
    resumeExport(e) {
      this.exportData.resumeData = e;
      var str = JSON.stringify(this.exportData);
      var element = document.createElement('a');
      element.setAttribute('href', 'data:application/json;charset=utf-8,' + encodeURIComponent(str));
      element.setAttribute('download', "resume.json");
      element.style.display = 'none';
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    },

    // Toggles the print preview value
    togglePreview() {
      switch (this.previewToggle) {
        case false:
          this.previewToggle = true;
          break;
        case true:
          this.previewToggle = false;
          break;
      }
    }
  }
}
</script>

<style>
body {
  background-color: rgb(238, 240, 245);
}
</style>
